export default __webpack_public_path__ + "static/media/Winner1.660406e2.svg";